import { getShopInfo, bindShop, getOrderAppReminders, ackOrderAppReminders } from "../../../api/wxshop/shop.js";

let modules = {
	namespaced: true,
	state: {
	},
	mutations: {
	},
	actions: {
		getShopInfoAction(conText, payload) {
			getShopInfo(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		bindShopAction(conText, payload) {
			bindShop(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		getOrderAppRemindersAction(conText, payload) {
			getOrderAppReminders(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		ackOrderAppRemindersAction(conText, payload) {
			ackOrderAppReminders(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
	}
}
export default modules;
